import React from "react"
import { Link } from "gatsby"
import { Row, Col, Container, Button } from "react-bootstrap"
import { safeName } from '../../components/Utilities/Safe-name'


function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}


function filterProducts(data, title, btnVariant, btnSize, jumboClassTitle) {
  // console.log(data)
  // console.log(title)

  // list output
  // -----------------------------------
  let list = []; // list layout container
  let variant = "primary",
    size = "",
    titleClass = ""

  if (btnVariant !== "") {
    variant = btnVariant
  }

  if (btnSize !== "") {
    size = btnSize
  }

  if (jumboClassTitle !== "") {
    titleClass = jumboClassTitle
  }

  if(data && data.length > 0) {
    shuffle(data) // mix it up
  }

  if(typeof data === 'object') {
    data.map(function(node, index) {

      let field_hex_color = "#fff"
      let colour_class = "understanding-finance" // default = link to understanding finance article
      let link_text = "Find out more"
      let link_prefix = ""

      if(node.relationships) {
        if(node.relationships.field_background_colour) {
          field_hex_color = node.relationships.field_background_colour.field_hex_color
          colour_class = safeName(node.relationships.field_background_colour.name)
        }
      }
      else {
        link_prefix = "More on:"
        link_text = node.title
      }

      // deal with super long summaries
      // trim to the first .
      let field_summary_plain = ""
      if(node.field_summary_plain) field_summary_plain = node.field_summary_plain

      if(field_summary_plain.length > 300) {
        field_summary_plain = field_summary_plain.split(".")[0]
      }

      list.push (
        <div key={index} className={`jumbotron ${colour_class}`} style={{ background: field_hex_color }}>
          <h3 className={titleClass}>{node.title}</h3>
          <p className="summary-plain">{field_summary_plain}</p>
          <p className="link-prefix">{link_prefix}</p>
          <Link to={node.path.alias}>
            <Button variant={variant} size={size}>{link_text}</Button>
          </Link>
        </div>
      )
      return true;

    })
  }

  if(list.length > 0){
    let returnTitle = ""
    if(title !== "") {
      returnTitle = (
        <Row>
          <Col>
            <h5>{title}</h5>
          </Col>
        </Row>
      )
    }
    const returnTeasers = (
      <Container fluid className="text-center product-teaser__container">
        {returnTitle}
        <Row className="text-left">
        {list}
        </Row>
      </Container>
    )
    return (returnTeasers)
  }
  else {
    return (list)
  }

}



const ProductTeasers = (props) => {

  return (
    <>
      {filterProducts(props.data, props.title, props.btnVariant, props.btnSize, props.jumboClassTitle)}
    </>
  )
}


export default ProductTeasers
